import { render, staticRenderFns } from "./CardAttraction.vue?vue&type=template&id=0b1f04df&scoped=true"
import script from "./CardAttraction.vue?vue&type=script&lang=js"
export * from "./CardAttraction.vue?vue&type=script&lang=js"
import style0 from "./CardAttraction.vue?vue&type=style&index=0&id=0b1f04df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f04df",
  null
  
)

export default component.exports